import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule, ModalController } from '@ionic/angular';
import { PropertyService } from '@smartflip/helper-utils';
import { defaultMinYearBuilt } from '../comparables.constants';
import { ComparablesFilterComponent } from '../comparables-filter/comparables-filter.component';
import { shouldPullCompsFromFilters } from '@smartflip/interactive-map';
import { PropertyDetailsService } from 'apps/app/src/app/views/property-details/property-details.service';

@Component({
  selector: 'lib-comparables-header',
  imports: [CommonModule, IonicModule],
  templateUrl: './comparables-header.component.html',
  styleUrl: './comparables-header.component.scss',
})
export class ComparablesHeaderComponent {
  @Input() showMapToggle = true; // show/hide the check box
  @Input() showMap: boolean = true; // value of the check box
  @Output() showMapChange = new EventEmitter<boolean>();
  @Output() filterChanged = new EventEmitter<Record<string, unknown>>();
  public displayAddress$ = this.propertyDetailsService.displayAddress$;

  constructor(
    private modalController: ModalController,
    private propertyService: PropertyService,
    private propertyDetailsService: PropertyDetailsService,
  ) {}

  private handleFilterComps(filterParams: Record<string, number>) {
    const updatedParams = shouldPullCompsFromFilters(filterParams) || {
      minYearBuilt: defaultMinYearBuilt,
      maxYearBuilt: new Date().getFullYear(),
    };
    const { minYearBuilt, maxYearBuilt } = updatedParams as {
      minYearBuilt: any;
      maxYearBuilt: any;
    };
    const thisYear = new Date().getFullYear();

    if (!minYearBuilt || minYearBuilt === defaultMinYearBuilt) {
      delete updatedParams['minYearBuilt'];
    }

    if (!maxYearBuilt || maxYearBuilt === thisYear) {
      delete updatedParams['maxYearBuilt'];
    }

    // OK to set compsFilters to null or empty object
    this.propertyService.updateProperty(
      'compsFilters',
      updatedParams,
      this.propertyService.propertyId,
    );

    this.filterChanged.emit(updatedParams);
  }

  public toggleMap(): void {
    this.showMap = !this.showMap;
    this.showMapChange.emit(this.showMap);
  }

  public async showFilter() {
    const existingFormFilters =
      this.propertyService.currentProperty.compsFilters || {};
    // Set defaults for the yearFilter Values
    existingFormFilters['minYearBuilt'] =
      existingFormFilters['minYearBuilt'] || defaultMinYearBuilt;
    existingFormFilters['maxYearBuilt'] =
      existingFormFilters['maxYearBuilt'] || new Date().getFullYear();

    const modal = await this.modalController.create({
      component: ComparablesFilterComponent,
      componentProps: {
        filterData: existingFormFilters,
      },
    });

    await modal.present();

    const { data } = await modal.onWillDismiss();

    if (data) {
      this.handleFilterComps(data);
    }
  }
}
